import {
  File,
  FileArchive,
  FileImage,
  FileSpreadsheet,
  FileText,
  LucideIcon,
} from 'lucide-react';

const EXTENSION_ICONS: Record<string, LucideIcon> = {
  pdf: FileText,
  png: FileImage,
  jpg: FileImage,
  jpeg: FileImage,
  gif: FileImage,
  webp: FileImage,
  svg: FileImage,
  heic: FileImage,
  xlsx: FileSpreadsheet,
  xls: FileSpreadsheet,
  csv: FileSpreadsheet,
  zip: FileArchive,
  rar: FileArchive,
  '7z': FileArchive,
};

const matchContentType = (contentType: string): LucideIcon | null => {
  const type = contentType.toLowerCase();
  if (type === 'application/pdf') return FileText;
  if (type.startsWith('image/')) return FileImage;
  if (
    type === 'text/csv' ||
    type.includes('spreadsheet') ||
    type.includes('excel')
  ) {
    return FileSpreadsheet;
  }
  if (type.includes('zip') || type.includes('compressed')) return FileArchive;
  return null;
};

/**
 * Ikona typu pliku. `contentType` bywa pusty albo generyczny
 * (`application/octet-stream`), więc rozszerzenie z nazwy jest zapasowym źródłem.
 */
export const getFileIcon = (
  contentType?: string | null,
  fileName?: string | null,
): LucideIcon => {
  const byContentType = contentType ? matchContentType(contentType) : null;
  if (byContentType) return byContentType;

  const dotIndex = fileName?.lastIndexOf('.') ?? -1;
  if (fileName && dotIndex > 0) {
    const extension = fileName.slice(dotIndex + 1).toLowerCase();
    if (EXTENSION_ICONS[extension]) return EXTENSION_ICONS[extension];
  }

  return File;
};
